import React from 'react';
import { Container, Typography, Grid, Box } from '@mui/material';

const MotivationalMessage = () => {
  const cardStyles = {
    background: 'rgb(0, 0, 0)',
    backdropFilter: 'blur(10px)',
    padding: { xs: 4, sm: 5 },
    borderRadius: '20px',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    boxShadow: '0px 15px 30px rgba(0, 0, 0, 0.3)',
    transition: '0.3s ease-in-out',
    textAlign: 'center',
    '&:hover': {
      boxShadow: '0px 25px 50px rgba(0, 0, 0, 0.4)',
      borderColor: '#1E90FF',
    },
  };

  const headingStyles = {
    fontWeight: 400,
    fontSize: { xs: '1.3rem', sm: '1.4rem', md: '1.5rem' },
    color: 'white',
    letterSpacing: 1,
    mb: 2,
    transition: 'color 0.3s',
    '&:hover': {
      color: '#1E90FF',
    },
  };

  const textStyles = {
    fontWeight: 300,
    fontSize: { xs: '1rem', sm: '1rem', md: '1rem' },
    color: 'white',
    letterSpacing: 1,
    lineHeight: 1.6,
  };

  return (
    <Container
      maxWidth="xl"
      sx={{
        background: 'linear-gradient(135deg, #000000, #000000)',
        py: { xs: 8, sm: 10, md: 12 },
        minHeight: '50vh',
      }}
    >
      <Typography
              variant="h4"
              sx={{
                textAlign: 'center',
                fontWeight: 500,
                fontSize: { xs: '1.8rem', md: '2rem' },
                color: '#fff',
                textTransform: 'uppercase',
                letterSpacing: 2,
                mb: 5,
                '&:hover': {
                  color: '#1E90FF',
                },
              }}
            >
              What you can do?
            </Typography>
      <Grid
        container
        spacing={5}
        justifyContent="center"
        alignItems="stretch"
      >
        {/* Share Knowledge Card */}
        <Grid item xs={12} md={4}>
          <Box sx={cardStyles}>
            <Typography sx={headingStyles}>
              Share Your Knowledge, Empower Others
            </Typography>
            <Typography sx={textStyles}>
              If you have talent, skills, or knowledge, our platform enables you to share it with those in need. Post content on topics that interest you, in the language you choose, and make a positive impact on the world around you.
            </Typography>
          </Box>
        </Grid>

        {/* Ask & Learn Card */}
        <Grid item xs={12} md={4}>
          <Box sx={cardStyles}>
            <Typography sx={headingStyles}>
              Got Questions? Ask and Learn!
            </Typography>
            <Typography sx={textStyles}>
              Have a doubt, query, or need to learn about a specific topic? Our platform’s request feature enables you to ask questions and receive answers from experts. Ask in the language you prefer and get personalized responses tailored to your learning needs.
            </Typography>
          </Box>
        </Grid>

        {/* Expert Session Card */}
        <Grid item xs={12} md={4}>
          <Box sx={cardStyles}>
            <Typography sx={headingStyles}>
              Want to Learn from Experts? Request a Session!
            </Typography>
            <Typography sx={textStyles}>
              Looking to deepen your knowledge? Choose a verified expert and request a personalized one-on-one session on any topic of your interest. Connect in the language of your choice and take your learning to the next level!
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default MotivationalMessage;
